import { RootState } from '../../store/rootReducer';

export const FaqTeaserContentSelector = (state: RootState) => state.content.faqTeaser;
